//libs
import { DialogTitle } from "@headlessui/react";
//components
import Button from "components/Button";
import ModalDialog from "components/ModalDialog";

export default function CongratulationModal({ open, setOpen, setSelectedTab }) {
  return (
    <ModalDialog open={open} setOpen={setOpen} size="sm">
      <div className="space-y-4">
        <DialogTitle
          as="h3"
          className="text-base font-semibold leading-6 text-gray-900"
        >
          Congratulations!
        </DialogTitle>
        <div className="space-y-2">
          <p>You have successfully submitted your tender.</p>
          <p>
            we’ll notify any updates to you. We might engage with you time to
            time for clarification and negotiations. Good luck!
          </p>
        </div>
        <div className="sm:flex gap-3 w-full">
          <Button
            type="button"
            data-autofocus
            onClick={() => {
              setOpen(false);
              setSelectedTab("overview");
            }}
          >
            Thank You
          </Button>
        </div>
      </div>
    </ModalDialog>
  );
}
